(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function urCartCountPulse() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let lastCount = null;
    const readCount = (root) => {
      const bubble = root.querySelector ? root.querySelector('.cart-count-bubble [aria-hidden="true"]') : null;
      if (!bubble) return 0;
      const n = parseInt(bubble.textContent, 10);
      return Number.isFinite(n) ? n : 0;
    };
    lastCount = readCount(cartIcon);

    const triggerPulse = () => {
      const bubble = cartIcon.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('is-pulsing');
      void bubble.offsetWidth;
      bubble.classList.add('is-pulsing');
      bubble.addEventListener('animationend', () => bubble.classList.remove('is-pulsing'), { once: true });
    };

    const observer = new MutationObserver(() => {
      const next = readCount(cartIcon);
      if (next !== lastCount && next > 0) {
        lastCount = next;
        triggerPulse();
      } else {
        lastCount = next;
      }
    });
    observer.observe(cartIcon, { childList: true, subtree: true, characterData: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ur-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Filter panel toggle
  var toggle = document.getElementById('URFilterToggle');
  var panel  = document.getElementById('URFilterPanel');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      panel.setAttribute('aria-hidden', String(!isOpen));
    });
  }

  // Auto-submit on checkbox / pill change
  var form = document.getElementById('URFiltersForm');
  if (form) {
    form.querySelectorAll('.ur-cg__check-input, .ur-cg__pill-input').forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
  }

  // Auto-submit sort
  var sortSelect = document.getElementById('URSortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      document.getElementById('URSortForm').submit();
    });
  }

  // Price range — output + fill bar + min/max guard
  document.querySelectorAll('[data-ur-price]').forEach(function (priceEl) {
    var rangeMax = parseFloat(priceEl.dataset.rangeMax) || 100;
    var minInput = priceEl.querySelector('.ur-cg__range--min');
    var maxInput = priceEl.querySelector('.ur-cg__range--max');
    var fill = priceEl.querySelector('[data-ur-price-fill]');
    if (!minInput || !maxInput || !fill) return;

    function updateFill() {
      var minV = parseFloat(minInput.value);
      var maxV = parseFloat(maxInput.value);
      if (minV > maxV - 1) {
        if (this === minInput) minInput.value = maxV - 1;
        else maxInput.value = minV + 1;
        minV = parseFloat(minInput.value);
        maxV = parseFloat(maxInput.value);
      }
      var minPct = (minV / rangeMax) * 100;
      var maxPct = (maxV / rangeMax) * 100;
      fill.style.left = minPct + '%';
      fill.style.right = (100 - maxPct) + '%';
      var minOut = document.getElementById(minInput.dataset.output);
      var maxOut = document.getElementById(maxInput.dataset.output);
      if (minOut) minOut.textContent = minInput.value;
      if (maxOut) maxOut.textContent = maxInput.value;
    }
    minInput.addEventListener('input', updateFill);
    maxInput.addEventListener('input', updateFill);
    updateFill();
  });

  // Quick add — single-variant products only
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ur-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var id = btn.dataset.variantId;
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adicionando...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && res.data.description || 'Erro');
        btn.textContent = 'Adicionado ✓';
        document.dispatchEvent(new CustomEvent('ur:cart:open'));
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ur-featured-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.ur-fp');
  sections.forEach(function (section) {
    /* ============ SLIDER ============ */
    var media = section.querySelector('[data-ur-fp-media]');
    if (media) {
      var slides = section.querySelectorAll('[data-ur-fp-slide]');
      var dots = section.querySelectorAll('[data-ur-fp-dot]');
      var prevBtn = section.querySelector('[data-ur-fp-prev]');
      var nextBtn = section.querySelector('[data-ur-fp-next]');
      var current = 0;
      var total = slides.length;

      var show = function (idx) {
        if (total === 0) return;
        idx = ((idx % total) + total) % total;
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === idx);
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        current = idx;
      };

      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); show(current + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function (e) {
          e.preventDefault();
          show(parseInt(d.getAttribute('data-ur-fp-dot'), 10) || 0);
        });
      });

      media.setAttribute('tabindex', '0');
      media.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
      });
    }

    /* ============ SIZE PICKER ============ */
    var sizeBtns = section.querySelectorAll('[data-ur-fp-size]');
    var hiddenIdInput = section.querySelector('input[name="id"]');
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (b.disabled) return;
        var variantId = b.getAttribute('data-variant-id');
        if (!variantId) return;

        sizeBtns.forEach(function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-active');
        b.setAttribute('aria-checked', 'true');

        if (hiddenIdInput) hiddenIdInput.value = variantId;
      });
    });

    /* ============ AJAX ADD-TO-CART ============ */
    var form = section.querySelector('[data-ur-fp-form]');
    if (!form) return;
    var btnText = form.querySelector('[data-ur-fp-btn-text]');
    var originalText = btnText ? btnText.textContent : '';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      if (btnText) btnText.textContent = 'Adicionando…';

      var formData = new FormData(form);
      var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(url, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (res.ok) {
            if (btnText) btnText.textContent = 'Adicionado ao carrinho';
            document.dispatchEvent(new CustomEvent('ur:cart:open'));
            setTimeout(function () {
              if (btnText) btnText.textContent = originalText;
              if (btn) btn.disabled = false;
            }, 1600);
          } else {
            if (btnText) btnText.textContent = res.data.description || 'Erro';
            setTimeout(function () {
              if (btnText) btnText.textContent = originalText;
              if (btn) btn.disabled = false;
            }, 2400);
          }
        })
        .catch(function () {
          if (btnText) btnText.textContent = 'Erro, tente de novo';
          setTimeout(function () {
            if (btnText) btnText.textContent = originalText;
            if (btn) btn.disabled = false;
          }, 2400);
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ur-first-purchase-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'ur_first_purchase_popup';
    var SUBMITTED_KEY = 'ur_first_purchase_popup_submitted';

    function safeStorageGet(key) {
      try { return localStorage.getItem(key); } catch (e) { return null; }
    }
    function safeStorageSet(key, value) {
      try { localStorage.setItem(key, value); } catch (e) { /* noop */ }
    }

    function readBool(el, attr) {
      var v = (el.getAttribute(attr) || '').toLowerCase();
      return v === 'true' || v === '1';
    }

    function init() {
      var popup = document.querySelector('[data-ur-popup]');
      if (!popup) return;

      var onlyHome = readBool(popup, 'data-only-home');
      var path = window.location.pathname;
      var isHome = path === '/' || path === '' || /^\/(?:[a-z]{2}(?:-[A-Z]{2})?)?\/?$/.test(path);
      if (onlyHome && !isHome) return;

      var showMobile = readBool(popup, 'data-show-mobile');
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
      if (!showMobile && isMobile) return;

      // Suppress if user already has discount applied via /discount/ landing or referral code captured this session
      try {
        if (sessionStorage.getItem('ur_referral_code')) return;
      } catch (e) { /* noop */ }

      var delay = parseFloat(popup.getAttribute('data-delay') || '6') * 1000;
      var cooldownDays = parseFloat(popup.getAttribute('data-cooldown-days') || '30');
      var scrollPct = parseFloat(popup.getAttribute('data-scroll-pct') || '0');

      var submitted = safeStorageGet(SUBMITTED_KEY);
      if (submitted) return;

      var dismissedAt = parseInt(safeStorageGet(STORAGE_KEY) || '0', 10);
      if (dismissedAt) {
        var cooldownMs = cooldownDays * 24 * 60 * 60 * 1000;
        if (Date.now() - dismissedAt < cooldownMs) return;
      }

      var triggered = false;
      function open() {
        if (triggered) return;
        triggered = true;
        popup.hidden = false;
        // Force reflow then add class for transition
        // eslint-disable-next-line no-unused-expressions
        popup.offsetHeight;
        popup.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        var emailInput = popup.querySelector('input[type="email"]');
        if (emailInput) setTimeout(function () { emailInput.focus({ preventScroll: true }); }, 320);
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'first_purchase_popup_open' });
        } catch (e) { /* noop */ }
      }

      function close(persistDismiss) {
        popup.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        if (persistDismiss !== false) {
          safeStorageSet(STORAGE_KEY, String(Date.now()));
        }
        setTimeout(function () { popup.hidden = true; }, 320);
      }

      // Delay trigger
      var delayTimer = null;
      if (delay > 0) {
        delayTimer = setTimeout(open, delay);
      }

      // Scroll trigger
      function onScroll() {
        if (triggered) return window.removeEventListener('scroll', onScroll);
        var docH = document.documentElement.scrollHeight - window.innerHeight;
        if (docH <= 0) return;
        var pct = (window.scrollY / docH) * 100;
        if (pct >= scrollPct) {
          if (delayTimer) clearTimeout(delayTimer);
          window.removeEventListener('scroll', onScroll);
          open();
        }
      }
      if (scrollPct > 0) {
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      // Exit intent (desktop only)
      function onExit(e) {
        if (triggered) return document.removeEventListener('mouseout', onExit);
        if (e.clientY < 8 && !e.relatedTarget) {
          if (delayTimer) clearTimeout(delayTimer);
          document.removeEventListener('mouseout', onExit);
          open();
        }
      }
      if (!isMobile) {
        document.addEventListener('mouseout', onExit);
      }

      // Close handlers
      popup.querySelectorAll('[data-ur-popup-close]').forEach(function (el) {
        el.addEventListener('click', function () { close(true); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) close(true);
      });

      // Form submission via fetch (no page reload)
      var form = popup.querySelector('form.ur-popup__form');
      var submitBtn = popup.querySelector('[data-ur-popup-submit]');
      var errorEl = popup.querySelector('[data-ur-popup-error]');
      var formState = popup.querySelector('[data-ur-popup-state="form"]');
      var successState = popup.querySelector('[data-ur-popup-state="success"]');

      if (form) {
        // Preserve the real endpoint then neutralise the form so neither the
        // Shopify Forms app nor any native fallback can submit the page away.
        var originalAction = form.getAttribute('action') || '/contact';
        form.setAttribute('action', 'javascript:void(0)');
        form.setAttribute('target', '_self');

        function handleSubmit(e) {
          if (e) {
            e.preventDefault();
            if (typeof e.stopImmediatePropagation === 'function') {
              e.stopImmediatePropagation();
            }
            e.stopPropagation();
          }

          var emailEl = form.querySelector('input[name="contact[email]"]');
          if (emailEl && !emailEl.checkValidity()) {
            emailEl.reportValidity();
            return false;
          }

          if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
          if (submitBtn) { submitBtn.disabled = true; submitBtn.querySelector('.ur-popup__cta-text').textContent = 'Enviando…'; }

          var data = new FormData(form);

          // The submit succeeds at the backend regardless of how Shopify responds
          // (302 redirect, opaqueredirect on manual mode, 200 with HTML, or 422
          // from the Forms app when the email is duplicated). Any network round
          // trip = customer was reached. We only surface error on hard failure.
          fetch(originalAction, {
            method: 'POST',
            headers: { 'Accept': 'text/html,application/xhtml+xml', 'X-Requested-With': 'XMLHttpRequest' },
            body: data,
            credentials: 'same-origin',
            redirect: 'follow'
          })
            .then(function () { onSuccess(); })
            .catch(function () {
              if (errorEl) {
                errorEl.hidden = false;
                errorEl.textContent = 'Não conseguimos enviar agora. Tenta de novo em instantes.';
              }
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.querySelector('.ur-popup__cta-text').textContent = submitBtn.dataset.originalLabel || 'Quero meu cupom';
              }
            });

          return false;
        }

        // Capture phase + stopImmediatePropagation runs before any handler the
        // Shopify Forms app or other scripts attach to the same form.
        form.addEventListener('submit', handleSubmit, true);

        // Belt and braces: also catch the click directly on the CTA so we
        // intervene even if some script rebinds the submit event on bubble.
        if (submitBtn) {
          submitBtn.addEventListener('click', function (e) {
            e.preventDefault();
            handleSubmit(e);
          });
        }
      }

      function onSuccess() {
        safeStorageSet(SUBMITTED_KEY, String(Date.now()));
        if (formState) formState.hidden = true;
        if (successState) successState.hidden = false;
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'first_purchase_popup_subscribe' });
        } catch (e) { /* noop */ }
      }

    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ur-page-history"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document;
    const items = root.querySelectorAll('.ur-story-page [data-reveal]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(el => el.classList.add('is-in'));
      return;
    }

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          // Stagger by sibling index inside the same chapter
          const idx = Array.from(e.target.parentNode.querySelectorAll('[data-reveal]')).indexOf(e.target);
          e.target.style.transitionDelay = (idx * 80) + 'ms';
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    items.forEach(el => obs.observe(el));

    // Hero parallax
    const heroBg = root.querySelector('.ur-sp-hero__bg');
    if (heroBg && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const scrollY = window.scrollY;
            if (scrollY < window.innerHeight * 1.2) {
              heroBg.style.transform = `translate3d(0, ${scrollY * 0.18}px, 0)`;
            }
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ur-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var sectionId = document.currentScript
    ? document.currentScript.closest('[data-section-id]')
    : null;

  // Bootstrap all ur-product sections on the page
  function initSection(sectionEl) {
    var id = sectionEl.dataset.sectionId;
    if (!id) return;

    var variantsEl = document.getElementById('ur-pd-variants-' + id);
    if (!variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent);

    // --- Collect pill containers ---
    var optionContainers = sectionEl.querySelectorAll('.ur-pd__option');

    function getSelectedOptions() {
      var selected = [];
      optionContainers.forEach(function (container) {
        var active = container.querySelector('.ur-pd__pill.is-active');
        if (active) {
          selected.push(active.dataset.value);
        }
      });
      return selected;
    }

    function findVariant(selectedOptions) {
      return variants.find(function (v) {
        return selectedOptions.every(function (val, idx) {
          return v['option' + (idx + 1)] === val;
        });
      }) || null;
    }

    function updatePrice(variant) {
      var priceEl = document.getElementById('ur-pd-price-' + id);
      if (!priceEl || !variant) return;

      // Format cents to currency string (Brazilian style)
      function formatMoney(cents) {
        var val = (cents / 100).toFixed(2).replace('.', ',');
        return 'R$ ' + val;
      }

      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<span class="price__sale">' +
          '<span class="visually-hidden">Preço promocional</span>' +
          '<span class="price-item price-item--sale">' + formatMoney(variant.price) + '</span>' +
          '</span>' +
          '<span class="price__compare">' +
          '<span class="visually-hidden">Preço original</span>' +
          '<span class="price-item price-item--regular">' + formatMoney(variant.compare_at_price) + '</span>' +
          '</span>';
      } else {
        html = '<span class="price__regular">' +
          '<span class="visually-hidden">Preço</span>' +
          '<span class="price-item price-item--regular">' + formatMoney(variant.price) + '</span>' +
          '</span>';
      }
      priceEl.innerHTML = html;

      // Update installments display if present
      var installmentsEl = sectionEl.querySelector('.ur-pd__installments');
      if (installmentsEl) {
        var match = installmentsEl.textContent.match(/(\d+)/);
        if (match) {
          var count = parseInt(match[1], 10);
          var perInstallment = (variant.price / 100 / count).toFixed(2).replace('.', ',');
          installmentsEl.textContent = 'ou ' + count + '× R$ ' + perInstallment + ' sem juros';
        }
      }
    }

    function updateVariantInputs(variant) {
      if (!variant) return;
      sectionEl.querySelectorAll('.ur-pd__variant-id').forEach(function (input) {
        input.value = variant.id;
      });
    }

    function updateAddBtn(variant) {
      var btn = sectionEl.querySelector('.ur-pd__btn--primary[name="add"]');
      if (!btn) return;
      if (!variant || !variant.available) {
        btn.disabled = true;
        btn.textContent = 'Indisponível';
      } else {
        btn.disabled = false;
        btn.textContent = 'Adicionar ao carrinho';
      }
    }

    function getMaxQty(variant) {
      if (!variant) return 1;
      if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
        return Math.max(1, variant.inventory_quantity || 1);
      }
      return 99;
    }

    function updateQtyBounds(variant) {
      if (!qtyInput) return;
      var max = getMaxQty(variant);
      qtyInput.max = max;
      var current = parseInt(qtyInput.value, 10) || 1;
      if (current > max) qtyInput.value = max;
      if (minusBtn) minusBtn.disabled = parseInt(qtyInput.value, 10) <= 1;
      if (plusBtn) plusBtn.disabled = parseInt(qtyInput.value, 10) >= max;
    }

    function onOptionChange() {
      var selectedOptions = getSelectedOptions();
      var variant = findVariant(selectedOptions);
      updateVariantInputs(variant);
      updatePrice(variant);
      updateAddBtn(variant);
      updateQtyBounds(variant);
    }

    // Pill click / keyboard handler
    optionContainers.forEach(function (container) {
      var pills = container.querySelectorAll('.ur-pd__pill');

      pills.forEach(function (pill) {
        function select() {
          if (pill.classList.contains('is-unavail')) return;
          pills.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('aria-checked', 'false');
          });
          pill.classList.add('is-active');
          pill.setAttribute('aria-checked', 'true');
          onOptionChange();
        }

        pill.addEventListener('click', select);
        pill.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(); }
        });
      });
    });

    // --- Quantity stepper ---
    var qtyInput = sectionEl.querySelector('.ur-pd__qty-input');
    var minusBtn = sectionEl.querySelector('.ur-pd__qty-btn--minus');
    var plusBtn = sectionEl.querySelector('.ur-pd__qty-btn--plus');

    if (qtyInput && minusBtn && plusBtn) {
      function refreshStepperBtns() {
        var val = parseInt(qtyInput.value, 10) || 1;
        var max = parseInt(qtyInput.max, 10) || 99;
        minusBtn.disabled = val <= 1;
        plusBtn.disabled = val >= max;
      }

      minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) { qtyInput.value = val - 1; }
        refreshStepperBtns();
      });

      plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        var max = parseInt(qtyInput.max, 10) || 99;
        if (val < max) { qtyInput.value = val + 1; }
        refreshStepperBtns();
      });

      qtyInput.addEventListener('input', function () {
        var val = parseInt(qtyInput.value, 10);
        var max = parseInt(qtyInput.max, 10) || 99;
        if (isNaN(val) || val < 1) qtyInput.value = 1;
        if (val > max) qtyInput.value = max;
        refreshStepperBtns();
      });

      refreshStepperBtns();
    }

    // --- Sync quantity from main form into "Comprar agora" hidden input on submit ---
    var buyForm = sectionEl.querySelector('.ur-pd__buy-form');
    if (buyForm && qtyInput) {
      var buyQtyInput = buyForm.querySelector('.ur-pd__buy-qty');
      buyForm.addEventListener('submit', function () {
        if (buyQtyInput) {
          var val = parseInt(qtyInput.value, 10) || 1;
          buyQtyInput.value = val;
        }
      });
    }

    // --- AJAX add to cart ---
    var addForm = sectionEl.querySelector('.ur-pd__form');
    if (addForm) {
      addForm.addEventListener('submit', function (e) {
        var btn = addForm.querySelector('.ur-pd__btn--primary[name="add"]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        btn.disabled = true;
        btn.textContent = 'Adicionando…';
        var formData = new FormData(addForm);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = 'Adicionado ao carrinho';
            var statusEl = addForm.querySelector('.ur-pd__cart-status');
            if (statusEl) statusEl.textContent = 'Produto adicionado ao carrinho';
            document.dispatchEvent(new CustomEvent('ur:cart:open'));
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = 'Adicionar ao carrinho';
              if (statusEl) statusEl.textContent = '';
            }, 2200);
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Adicionar ao carrinho';
            var statusEl = addForm.querySelector('.ur-pd__cart-status');
            if (statusEl) statusEl.textContent = 'Não foi possível adicionar o produto. Tente novamente.';
          });
      });
    }

    // --- Mobile gallery dots <-> scroll sync ---
    var galleryEl = sectionEl.querySelector('[data-ur-gallery]');
    if (galleryEl) {
      var trackEl = galleryEl.querySelector('[data-ur-gallery-track]');
      var dotEls = galleryEl.querySelectorAll('[data-ur-dot]');
      var slideEls = trackEl ? trackEl.querySelectorAll('[data-ur-slide]') : [];

      if (trackEl && dotEls.length > 0 && slideEls.length > 0) {
        var scrollRaf = null;
        function setActive(idx) {
          dotEls.forEach(function (d, i) {
            var on = i === idx;
            d.classList.toggle('is-active', on);
            d.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }

        trackEl.addEventListener('scroll', function () {
          if (scrollRaf) return;
          scrollRaf = requestAnimationFrame(function () {
            scrollRaf = null;
            var w = trackEl.clientWidth;
            if (!w) return;
            var idx = Math.round(trackEl.scrollLeft / w);
            if (idx < 0) idx = 0;
            if (idx > slideEls.length - 1) idx = slideEls.length - 1;
            setActive(idx);
          });
        }, { passive: true });

        dotEls.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var idx = parseInt(dot.dataset.urDot, 10) || 0;
            var target = slideEls[idx];
            if (target) {
              trackEl.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
              setActive(idx);
            }
          });
        });
      }
    }

    // --- Accordion toggle ---
    var accordionHeaders = sectionEl.querySelectorAll('.ur-pd__accordion-header');
    accordionHeaders.forEach(function (header) {
      header.addEventListener('click', function () {
        var expanded = header.getAttribute('aria-expanded') === 'true';
        var bodyId = header.getAttribute('aria-controls');
        var body = bodyId ? document.getElementById(bodyId) : null;

        header.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (body) {
          if (expanded) {
            body.hidden = true;
          } else {
            body.hidden = false;
          }
        }
      });
    });
  }

  // Init all product sections on DOMContentLoaded (handles Liquid rendering)
  function initAll() {
    document.querySelectorAll('.ur-pd[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor section:load re-init
  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('.ur-pd[data-section-id]');
    if (container) initSection(container);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ur-vip-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.ur-vip');
    sections.forEach(function (section) {
      var form = section.querySelector('form.ur-vip__form');
      if (!form) return;
      var cityInput = form.querySelector('[data-ur-vip-city]');
      var noteHidden = form.querySelector('input[name="contact[note]"]');
      if (!cityInput || !noteHidden) return;
      form.addEventListener('submit', function () {
        var city = (cityInput.value || '').trim();
        if (city) noteHidden.value = 'Cidade: ' + city;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
